module.exports = __webpack_public_path__ + "4a20d6dbb04df3f27cb872c1901e1ae4.jpg";